import React, { useState } from 'react';
import AnimatedPage from '../../../components/AnimatedPage';
import { Link } from 'react-router-dom';
import * as ROUTES from "../../../constants/routes";
import { motion, AnimatePresence } from 'framer-motion';

import Img1 from '../../../../images/journeyPages/growth/1.png';
import SubImg1 from '../../../../images/journeyPages/growth/1.1.png';
import Img2 from '../../../../images/journeyPages/growth/2.png';
import SubImg2 from '../../../../images/journeyPages/growth/2.1.png';
import Img3 from '../../../../images/journeyPages/growth/3.png';
import SubImg3 from '../../../../images/journeyPages/growth/3.1.png';
import Img4 from '../../../../images/journeyPages/growth/4.png';
import SubImg4 from '../../../../images/journeyPages/growth/4.1.png';
import Img5 from '../../../../images/journeyPages/growth/5.png';

const ImageData = [
    { main: Img1, subImg: SubImg1, subImgHeight: '190px' },
    { main: Img2, subImg: SubImg2, subImgHeight: '190px' },
    { main: Img3, subImg: SubImg3, subImgHeight: '190px' },
    { main: Img4, subImg: SubImg4, subImgHeight: '190px' },
    { main: Img5 }
];

const useIsMobile = () => {
    if (typeof window !== "undefined") {
        return window.innerWidth <= 768;
    }
    return false;
};

const GrowthReadyJourney = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const isMobile = useIsMobile();


    return (
        <AnimatedPage>
            <div style={{ background: '#f8fafc', minHeight: '100vh' }}>
                <div className='container' style={{ margin: '0 auto', padding: '2rem 0rem 0 0rem' }}>
                    <p className='c15 mb2rem'>
                        Growth Ready
                    </p>
                    <h2 className='c15 fw600 fs2rem mb0-5rem'>
                        Your journey with Diligentsia to growth
                    </h2>
                    <p className='c15 mb2rem fs18px font-poppins'>Self-improvement modules to turboboost your growth - or we can introduce an advisor to help you</p>
                </div>

                <div
                    className='w100 h100'
                    style={{
                        backgroundImage: `url(${require('../../../../images/journeyPages/background/bg.png')})`,
                        backgroundSize: '100%',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                    <div
                        className='df aifs jcc container'
                        style={{
                            background: `url(${require('../../../../images/journeyPages/growth/growthRoad.png')})`,
                            backgroundSize: isMobile ? "100% 100%" : "contain",
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            paddingBottom: isMobile ? '190px' : '250px'
                        }}
                    >

                        <div
                            className='py2rem px1rem dg '
                            style={{
                                maxWidth: isMobile ? '100%' : '60%'
                            }}
                        >

                            {
                                ImageData.map((imgData, index) => {
                                    const hasSubImage = !!imgData?.subImg;
                                    const isRight = index % 2 !== 0;
                                    return (
                                        <div
                                            key={index}
                                            className='my0-5rem pr'
                                            style={{
                                                position: 'relative',
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: isRight ? 'flex-end' : 'flex-start',
                                            }}
                                            onMouseEnter={() => !isMobile && setHoveredIndex(index)}
                                            onMouseLeave={() => !isMobile && setHoveredIndex(null)}
                                        >
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    height: (hasSubImage && imgData.subImgHeight) ? imgData.subImgHeight || 'auto' : 'auto',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                }}
                                            >
                                                {/* Main Image */}
                                                <img
                                                    src={imgData?.main}
                                                    alt={`image${index + 1}`}
                                                    style={{
                                                        maxWidth: isMobile ? '300px' : '420px',
                                                        position: 'relative',
                                                        left: isMobile ? "0" : isRight ? '50%' : '-50%',
                                                        transition: 'transform 0.3s ease',
                                                    }}
                                                />

                                                {/* Sub Image - Left or Right of Main */}
                                                <AnimatePresence>
                                                    {!isMobile && hoveredIndex === index && hasSubImage && (
                                                        <motion.img
                                                            key="subImg"
                                                            src={imgData.subImg}
                                                            alt={`subimage${index + 1}`}
                                                            initial={{
                                                                opacity: 0,
                                                                x: isMobile ? 0 : isRight ? 40 : -40,
                                                            }}
                                                            animate={{
                                                                opacity: 1,
                                                                x: 0,
                                                            }}
                                                            exit={{
                                                                opacity: 0,
                                                                x: isMobile ? 0 : isRight ? 20 : -20,
                                                            }}
                                                            transition={{ duration: 0.3 }}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '0%',
                                                                [isRight ? 'left' : 'right']: isMobile ? 0 : '150%',
                                                                transform: 'translateY(-50%)',
                                                                marginLeft: isMobile ? '' : isRight ? '1rem' : '',
                                                                marginRight: isMobile ? '' : !isRight ? '1rem' : '',
                                                                height: (hasSubImage && imgData.subImgHeight) ? imgData.subImgHeight || 'auto' : 'auto',
                                                                borderRadius: '10px',
                                                                zIndex: 10,
                                                            }}
                                                        />
                                                    )}
                                                </AnimatePresence>
                                            </div>
                                        </div>
                                    )
                                })
                            }

                            <Link
                                to={ROUTES.REGISTER}
                                className="bg4 fw700 fs0-75rem c1 py0-5rem px0-5rem df jcc aic br45px cp mt8rem mb10rem"
                                style={{ lineHeight: '25.5px', width: '400px', height: '70px' }}>
                                <div className="df jcc fdc aic w100">
                                    <div className='fs1-25rem'>Try for FREE</div>
                                    <div className="fw400 fs14px c21" style={{ lineHeight: '20px', fontStyle: 'italic' }}>No credit card required</div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </AnimatedPage>
    );
};

export default GrowthReadyJourney;